// extracted by mini-css-extract-plugin
export var attachment = "_se-a";
export var emailContainer = "_se-4";
export var emailContentPaddedContainer = "_se-b";
export var emailHeader = "_se-6";
export var emailIframe = "_se-3";
export var emailInfoIcon = "_se-9";
export var emailShortenedSummary = "_se-e";
export var infoDropdown = "_se-0";
export var infoRowBoundedContent = "_se-d";
export var internal = "_se-5";
export var merchant = "_se-8";
export var messageInputContainer = "_se-h";
export var normal = "_se-7";
export var replyCard = "_se-f";
export var subtleButton = "_se-1";
export var subtleButtonIconContainer = "_se-2";
export var toggleViewRepliesButton = "_se-c";
export var wrappingText = "_se-g";